import { configureStore, Action, ThunkAction } from "@reduxjs/toolkit";
import appLocalStorage from "./localStorage";
import workOrderSlice from "../components/store/queueBoardSlice";
import applicationReducer from "./appSlice";

// Load state from localStorage
//const preloadedState: typeof initialState = appLocalStorage.get();

// Configure the store
export const store = configureStore({
  reducer: {
    workOrderDashboard: workOrderSlice,
    applicationState: applicationReducer,
  },
});

// Save state to localStorage on store changes
store.subscribe(() => {
  appLocalStorage.save(store.getState());
});

// Define the RootState type
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;
